import { Vue } from 'nuxt-property-decorator';
import Intersect from 'vue-intersect';
Vue.component('Intersect', Intersect);
